export default __webpack_public_path__ + "static/media/tent-icon.b3a80665.png";